module.exports = __webpack_public_path__ + "media/images/crosspoint_favicon-00aa2891c1bfe1430da6b3b26a3795af.svg";